import React from "react";
import { useNavigate } from "react-router";
import { StyckeCompact } from "./ContentStyles";
import Rules from "./Rules";
import { Branding } from "../services/misc";
import "./PricePage.scss";
import { BsLightning } from "react-icons/bs";
import { FaStore } from "react-icons/fa";
import { IoWifi } from "react-icons/io5";
import { IoCartOutline } from "react-icons/io5";
import { GiReceiveMoney } from "react-icons/gi";
import { FaMobileAlt } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import PricingModule from "./PricingModule";

const PricePage = () => {
    const navigate = useNavigate();

    function handleSubmitProd(defaultproduct) {
        navigate("/signup?defaultproduct=" + defaultproduct);
    }

    const brandName =
        window.location.origin === "https://www.xn--nrbutik-5wa.se"
            ? "Närbutik.se"
            : "Nookshop";

    return (
        <>
            <Helmet>
                <title>{brandName} | Priser och abonnemang för obemannad butik</title>
                <meta
                    name="description"
                    content="Se priser och abonnemang för obemannad butik. Jämför kylskåp, micro, standard och large och välj paketet som passar din verksamhet bäst."
                />
            </Helmet>
            <div className="pricing-page">
                {/* HERO */}
                <section className="pricing-hero" aria-labelledby="pricing-page-title">
                    <div className="pricing-hero__inner">
                        <div className="pricing-pill">
                            <span className="pricing-pill__icon"><BsLightning aria-hidden="true" /></span>
                            <span className="pricing-pill__text">Våra abonnemang</span>
                        </div>

                        <h1 id="pricing-page-title" className="pricing-title">
                            Välj det <span className="pricing-title__accent">paket </span>som passar dina behov
                        </h1>

                        <p className="pricing-subtitle">
                            Jämför abonnemang för obemannad butik – från mindre kylskåpslösningar till kompletta butikssystem för gårdsbutik, kiosk eller närbutik.
                        </p>
                    </div>
                </section>



                <PricingModule></PricingModule>

            </div>
        </>
    );
};

export default PricePage;
